import React, { useEffect, useState } from "react";
import ArticleHeader from "../articleHeader/articleHeader";
import { Row, Col, Container } from "react-bootstrap";
import TextView from "../textView/textView";
import BoxedPlayer from "../boxedPlayer/boxedPlayer";
import ImageView from "../imageView/imageView";
import BlockQuote from "../blockquote/blockquote";
import RecomSlider from "../articleSlider/recomSlider";
import { getAWSUrl, getFullPageItem } from "../api/core";
import ImageSlider from "../newsCarousel/imageSlider";
import NotFound from "../notfound/notfound";
import Head from "../head/head";
import CarouselContentLoader from "../loader/contentLoader";
const Article = (props) => {
  const obj = { items: [] };
  const [blockQuote, setBlockQuote] = useState("");
  const [mainheader, setHeader] = useState("");
  const [textOne, setTextOne] = useState("");
  const [textTwo, setTextTwo] = useState("");
  const [textThree, setTextThree] = useState("");
  const [headerOne, setHeaderOne] = useState("");
  const [headerTwo, setHeaderTwo] = useState("");
  const [singleImage, setSingleImage] = useState("");
  const [cite, setCite] = useState("");
  const [author, setAuthor] = useState("");
  const [publishDate, setPublishDate] = useState("");
  const [singleVideo, setSingleVideo] = useState("");
  const [singleUrl, setSingleUrl] = useState("");
  const [itemImages, setItemImages] = useState([]);
  const [recommend, setRecommend] = useState(obj);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [web, SetWeb] = useState(true);
  const [artTitle, SetArtTitle] = useState("");

  useEffect(() => {
    const FullPageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullPageItem(app, id, 0, 10).then(
        (result) => {
          setBlockQuote(result.data.blockQuote);
          setCite(result.data.cite);
          setTextOne(result.data.introduction);
          setHeader(result.data.mainHeader);
          setAuthor(result.data.author);
          setPublishDate(result.data.publishDate);
          setHeaderOne(result.data.sectionHeader1);
          setHeaderTwo(result.data.sectionHeader2);
          setTextTwo(result.data.sectionDescription1);
          setTextThree(result.data.sectionDescription2);
          setSingleImage(result.data.bannerImage.imagekey);
          setSingleVideo(result.data.videoId);
          setSingleUrl(result.data.urlName);
          setItemImages(result.data.items);
          setRecommend(result.data.recommendation);
          SetWeb(result.data.devices[0].itemVisibility);
          SetArtTitle(result.data.displayName);
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    FullPageDetail(props.match.params.AppId, props.match.params.Id);
    isLoading(false);
  }, [props.match.params.Id, props.match.params.AppId]);

  if (!loading && !error && web) {
    return (
      <div>
        <Head
          title={artTitle}
          quote={artTitle}
          description={textOne}
          image={singleImage != null ? getAWSUrl() + singleImage !== null : ""}
        ></Head>
        <Container>
          <Row>
            <Col sm={12}>
              <ArticleHeader
                title={mainheader}
                author={author}
                publishDate={publishDate}
              ></ArticleHeader>
              {blockQuote !== null &&
              blockQuote !== undefined &&
              blockQuote !== "" ? (
                <BlockQuote quote={blockQuote} cite={cite}></BlockQuote>
              ) : (
                ""
              )}
              {textOne !== null && textOne !== undefined && textOne !== "" ? (
                <TextView
                  header={false}
                  textView={textOne}
                  fontSize={"15px"}
                ></TextView>
              ) : (
                ""
              )}
              {singleImage !== null &&
              singleImage !== undefined &&
              singleImage !== "" &&
              itemImages.length === 0 ? (
                <ImageView src={getAWSUrl() + singleImage}></ImageView>
              ) : (
                ""
              )}
              {itemImages !== null && itemImages !== undefined ? (
                <ImageSlider
                  id={singleUrl}
                  multiple={false}
                  artImage={itemImages}
                  {...props}
                ></ImageSlider>
              ) : (
                ""
              )}
              {textTwo !== null && textTwo !== undefined && textTwo !== "" ? (
                <TextView
                  header={true}
                  title={headerOne}
                  textView={textTwo}
                  fontSize={"15px"}
                ></TextView>
              ) : (
                ""
              )}
              {singleVideo !== null &&
              singleVideo !== undefined &&
              singleVideo !== "" ? (
                <BoxedPlayer videoId={singleVideo}></BoxedPlayer>
              ) : (
                ""
              )}
              {textThree !== null &&
              textThree !== undefined &&
              textThree !== "" ? (
                <TextView
                  header={true}
                  title={headerTwo}
                  textView={textThree}
                  fontSize={"15px"}
                ></TextView>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Container>
        <div style={{ marginTop: "10px" }}>
          {recommend != null &&
          (recommend.items.length > 0 || recommend.playlist !== "") ? (
            <RecomSlider
              name={"related_article"}
              description={true}
              news={true}
              tag={true}
              tabbed={false}
              dataset={recommend}
              {...props}
              x
            ></RecomSlider>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  } else {
    if (!web) {
      return (
        <div style={{ minHeight: "500px" }}>
          <NotFound
            code={"Hidden Page"}
            message={"This Page is Hidden in thw Website"}
          ></NotFound>
        </div>
      );
    } else if (loading) {
      return (
        <div style={{ minHeight: "400px" }}>
          <CarouselContentLoader />
        </div>
      );
    } else {
      return <div style={{ minHeight: "400px" }}></div>;
    }
  }
};

export default Article;
